// extracted by mini-css-extract-plugin
module.exports = {"OutputText":"OutputText_OutputText__v6PNi","OutputText_percentage":"OutputText_OutputText_percentage__3I7yp"};